<template>
  <div>
    <div class="fixed top-0 w-full pt-[8px] bg-white">
      <NavBar />
    </div>
    <div>
      <div class="w-[500px] h-auto px-10 top-[75px] mt-[25px] sm:fixed">
        <div class="w-1/2">
          <v-expansion-panels>
            <ExpansionPanelTitle title="Title Transfer" />
            <v-expansion-panel v-for="(item, i) in parent" :key="i">
              <v-expansion-panel-header>
                {{ item.title }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-for="(item, j) in item.child" :key="j">
                  <button
                    v-scroll-to="item.scroll_to"
                    class="
                      w-full
                      hover:text-red-900 hover:bg-gray-200
                      p-2
                      flex
                    "
                  >
                    {{ item.title }}
                  </button>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <!-- <a href="#" v-scroll-to="'#class1'">class 1</a> -->
        <!-- <v-btn-toggle class="flex-col">
          <div class="bg-red-200" v-for="(item, i) in items" :key="i">
            <v-btn
              class="w-full"
              v-scroll-to="item.scroll_to"
              small
              elevation=""
              color=""
            >
              {{ item.title }}
            </v-btn>
          </div>
        </v-btn-toggle> -->
      </div>
      <div class="sm:ml-[250px] sm:px-10 mt-[75px] min-w-[750px]">
        <InHouseMonetary
          class="class1 pt-[25px]"
          :hTitle="'InHouse Financing Monetary Requirements'"
        />
        <InHouseRequirements
          class="class2 pt-[25px]"
          :hTitle="'InHouse Financing Documentary Requirements'"
        />
        <BankingMonetary
          class="class3 pt-[25px]"
          :hTitle="'Banking Financing Monetary Requirements'"
        />
        <BankingRequirements
          class="class4 pt-[25px]"
          :hTitle="'Banking Financing Documentary Requirements'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ExpansionPanelTitle from "../../../components/ExpansionPanelTitle.vue";
import InHouseMonetary from "./InHouse-Monetary.vue";
import InHouseRequirements from "./InHouse-Requirements.vue";
import BankingMonetary from "./Banking-Monetary.vue";
import BankingRequirements from "./Banking-Requirements.vue";
import NavBar from "../../../../../common/NavBar-Fixed.vue";

export default {
  components: {
    ExpansionPanelTitle,
    NavBar,
    InHouseMonetary,
    InHouseRequirements,
    BankingMonetary,
    BankingRequirements,
  },
  data() {
    return {
      show: false,
      parent: [
        {
          title: "Inhouse Financing",
          id: 1,
          child: [
            {
              title: "Monetary Requirements",
              scroll_to: ".class1",
              id: 2,
            },
            {
              title: "Documents Requirements",
              scroll_to: ".class2",
              id: 3,
            },
          ],
        },
        {
          title: "Bank Financing",
          id: "4",
          child: [
            {
              title: "Monetary Requirements",

              scroll_to: ".class3",
              id: 5,
            },
            {
              title: "Documents Requirements",
              scroll_to: ".class4",
              id: 6,
            },
          ],
        },
      ],
    };
  },
};
</script>